<template>
    <div class="warning-handle-page">
        <m-pane ref="tablePage"
            class="warning-handle"
            searchId="warning-handle-query"
            pageID="warning-handle"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :searchTotalTitle="config.searchTotalTitle"
            :loading="loading"
            :pickerConfig="config.pickerConfig"
            :currentPage="query.pageNo"
            moduleCode="lsp-warning-handle-tab-v2"
            @handle-btn="openHandleDialog"
            @searchChange="searchChange"
            @row-db-click="onDblclick"
            @selectChange="selectChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
            <template v-slot:customTableCell="{ row, col }">
                <div class="table-list-encrypted-panel">
                    <span :style="cellStyle(row, col)">{{ row[col.prop] }}</span>
                </div>
            </template>
            <div slot="table-module-btn">
                <reportExport #default="{ submit }" :reportCode="config.reportCode">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="permissionCode.reportBtn" class="mgl-10">
                            <el-button icon="icon-daochu" size="mini"
                                :disabled="!pageTotal" @click="exportFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
        </m-pane>
        <HandleDialog
            v-if="dialogCtrl.visible"
            :row-data="dialogCtrl.row"
            @closed="dialogCtrl.visible = false"
            @success="getList"
        />

    </div>
</template>
<script>
import { mapState } from 'vuex';
import { formatSearchData, validateSearchData } from './util.js';
import config, { permissionCode } from './config.js';
import reportExport from '@/components/lots/reportExportPlugin';
import { fetchDictBy, getDictOptions } from '@/modules/transport/otp/utils/dictUtil.js';
import { hasPermission, strToArray } from '@/modules/transport/otp/utils/commonFun';
import bigDataLog from '@/utils/bigDataLog';
import { queryMonitorDealByPageApi, queryMonitorDealCountApi } from '@/modules/transport/otp/api/collusionWarning';

import { toString } from 'lodash';
import mPane from '@/components/otpPanel';
import HandleDialog from './components/HandleDialog.vue';

export default {
    name: 'CollusionWarningHandle',
    components: {
        mPane,
        reportExport,
        HandleDialog
    },
    data() {
        return {
            config,
            pageTotal: 0,
            loading: false,
            totalData: [],
            selected: [],
            query: { pageNo: 1, pageSize: 20 },
            rowData: {},
            permissionCode,
            dialogCtrl: {
                visible: false,
                row: {}
            }
        };
    },
    computed: {
        ...mapState({
            currentTenant: state => state.currentTenant,
            user: state => state.user,
            supplier: state => state.supplier,
        })
    },
    mounted() {
        this.queryWarningTypeOptions();
    },
    methods: {
        /** 预警类型： 按照【轨迹偏离预警、在途轨迹丢失预警、未在目的地抵达预警、抵达异常离场预警、线路变更预警、途径点异常预警】排序 */
        async queryWarningTypeOptions() {
            const searchRow = this.config.searchList.searchTxt.find(row => row.value === 'warningTypeList');
            const options = await getDictOptions('CHANGE_MONITOR_WARNING_TYPE');
            const SORTS = ['01', '05', '06', '04', '02', '03', '07', '08'];
            // 按照SORTS顺序排序
            const sortedOptions = SORTS.map(code => options.find(opt => opt.value === code)).filter(Boolean);
            // 设置到searchRow.options
            if (searchRow) {
                // lsp和el平台，只显示【轨迹偏离预警、在途轨迹丢失预警】
                searchRow.options = sortedOptions.filter(row =>  ['01', '05', '07', '08'].includes(row.value))
            }
        },
        // 列表查询
        async getList() {
            try {
                this.loading = true;
                const res = await queryMonitorDealByPageApi(this.query);
                if (res && +res.code === 0) {
                    this.totalData = await this.formatTotalDataList(res.data.list || []);
                }
            } finally {
                this.loading = false;
            }
        },
        // 列表数据格式化
        async formatTotalDataList(list) {
            const dictMap = await fetchDictBy({
                urgencyType: 'URGENCY_WARNING_TYPE',
                warningType: 'CHANGE_MONITOR_WARNING_TYPE',
                industry: 'SYS_SUPPLIER_INDUSTRY' // 行业
            });
            return list.map(row => {
                // 装卸方式，预警等级，预警类型
                row['__loadingMethod__'] = `${row.loadQty || 0}装${row.unloadQty || 0}卸`;
                row['__urgencyTypeName__'] = dictMap.urgencyType[row.urgencyType];
                row['__warningTypeName__'] = dictMap.warningType[row.warningType];

                // 多个行业，用"+"符号连接
                row['__industryCategory__'] = strToArray(row.industryCategory).map(item => {
                    return dictMap.industry[item];
                }).filter(Boolean).join(' + ');

                return row;
            });
        },
        // 查询列表总数量
        getListPageCount() {
            queryMonitorDealCountApi(this.query.param).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data || 0;
                }
            });
        },
        /**
         * @description 组装查询参数
         * @param {Object} data 查询参数
         */
        getSearchData(data) {
            const _searchData = {
                ...this.query,
                pageNo: 1,
                param: {
                    ...data,
                    carrierCode: this.supplier.supplierCode, // 供应商端需要加上供应商编码入参
                }
            };
            return _searchData;
        },

        // 查询
        searchChange(data) {
            const searchData = formatSearchData(data);
            const isQueryOk = validateSearchData(searchData);
            if (!isQueryOk) return;
            this.query = this.getSearchData(searchData);
            this.getList();
            this.getListPageCount();
            bigDataLog.sendDetailMessageByKey('bigData-btn-collusion-warning-handleTab-search');
        },
        // 导出
        exportFile(submit) {
            const exportParams = {
                beginDate: '2010-07-26 00:00:00', // 没有的字段，为了后端导出任务片段必填
                endDate: '2030-07-26 00:00:00',
                tenantCode: this.currentTenant.tenantCode,
                ...this.query.param
            };
            if (exportParams.monitorStatus === '3') {
                exportParams.monitorStatus = '';
            }
            submit(exportParams);
            bigDataLog.sendDetailMessageByKey('bigData-btn-collusion-warning-handleTab-export');
        },
        // 样式
        cellStyle(row, col) {
            if (col.prop === '__urgencyTypeName__' && toString(row.urgencyType) === '0') {
                return 'color: red; font-weight: bold';
            }
        },
        onDblclick(row) {
            // 判断是否有无按钮权限；
            if (!hasPermission(permissionCode.handleBtn)) return;
            if (+row.warningStatus !== 1) {
                return this.$message.warning('该明细已处理!');
            };
            this.openHandleDialog(row);
        },

        // 处理按钮
        openHandleDialog(row) {
            Object.assign(this.dialogCtrl, { visible: true, row });
            // 自定义埋点
            bigDataLog.sendDetailMessageByKey('bigData-btn-collusion-warning-handleTab-handleBtn');
        },
        selectChange(data) {
            this.selected = data;
        },
        // 切换当前页数
        pageChange(pageNo) {
            this.query.pageNo = pageNo;
            this.getList();
        },
        // 切换分页显示条数
        sizeChange(pageSize) {
            this.query.pageNo = 1;
            this.query.pageSize = pageSize;
            this.getList();
        }
    }
};
</script>
<style lang="less" scoped>
.warning-handle {
    ::v-deep .otp-table {
        .el-table {
            min-height: calc(~'100vh - 224px') !important;
            max-height: calc(~'100vh - 224px') !important;
        }
    }
}
</style>
